import {Grid, Box, Typography, Button} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import line from '../../../../images/icons/header/line.svg';
import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';

interface Props {
  changeStep (val: string, index: boolean): any;
  stepValue: number,
  selectedPreferencesCount: number
}

export default function Header({changeStep, stepValue, selectedPreferencesCount} : Props) {
  const theme = useTheme();

  const headerProps = {
    padding: 3,
    zIndex: 9999999,
    width: '100%',
    position: 'fixed',
    backgroundColor: theme.palette.grey[0]
  }

  const gridProps = {
    display: 'inline-grid',
    justifyContent: 'center',
    justifyItems: 'center',
    alignItems: 'center',
    gridGap: '3px'

  }

  const iconProps = {
    color: theme.palette.primary.darker,
    fontSize: 14
  }

  return (
    <Box sx={headerProps} maxWidth='sm'>
      <Grid container sx={{justifyContent: 'center'}} >
        <Grid item xs={2} sx={gridProps}>
          <CircleIcon sx={iconProps}  onClick={() => changeStep('home', false)} />
        </Grid>
        <Grid item xs={2}  sx={gridProps}>
          <img src={line} />
        </Grid>
        <Grid item xs={3}  sx={gridProps}>
          {stepValue >= 1 && <CircleIcon sx={iconProps} onClick={() => changeStep('diets', false)} />}
          {stepValue < 1 && <CircleOutlinedIcon sx={iconProps} onClick={() => changeStep('diets', false)} />}
        </Grid>
        <Grid item xs={2}  sx={gridProps}>
          <img src={line} />
        </Grid>
        <Grid item xs={2}  sx={gridProps}>
          {stepValue >= 2 && <CircleIcon sx={iconProps} onClick={() => changeStep('allergies', false)} />}
          {stepValue < 2 && <CircleOutlinedIcon sx={iconProps} onClick={() => changeStep('allergies', false)} />}
        </Grid>
      </Grid>
    </Box>
  );
}
